import type { WithShopifyCartLineFragment } from "~/shopify"
import { fromShopifyStorefrontId } from "./shopify"

export const collectionToGTM = (
  frontendBase: string,
  collection: {
    id: string
    title?: string | null | undefined
    handle: string
  }
) => ({
  item_list_id: Number(collection.id),
  item_list_name: collection.title,
  canonical_url: `${frontendBase}/shop/${collection.handle}`
})

export const productToGTM = (
  frontendBase: string,
  product: {
    id: string
    title?: string | null | undefined
    handle: string
    variants: Array<{
      id: string
      available: boolean
      title?: string | null | undefined
      price: number
    }>
    image?: {
      smallUrl: string
    } | null
  },
  quantity?: number | null | undefined
) => {
  const firstAvailable = product.variants
    .filter(variant => variant.available)
    .at(0)

  return {
    item_name: product.title,
    item_id: Number(product.id),
    price: firstAvailable?.price,
    variant_id: firstAvailable ? Number(firstAvailable.id) : null,
    variant: firstAvailable?.title,
    canonical_url: `${frontendBase}/products/${product.handle}`,
    image_url: product.image?.smallUrl,
    quantity: quantity
  }
}

export const shopifyLineItemToGTM = (
  frontendBase: string,
  line: WithShopifyCartLineFragment
) => ({
  item_name: line.merchandise.product.title,
  item_id: line.merchandise.product.id
    ? Number(fromShopifyStorefrontId(line.merchandise.product.id))
    : null,
  price: parseFloat(line.merchandise.price.amount),
  canonical_url: `${frontendBase}/products/${line.merchandise.product.handle}`
})
